import React, { useEffect, useState } from 'react';
import { View, TextInput, StyleSheet , Text} from 'react-native';
import { FONT_STYLE } from '../../dataSchema/const';

const Email = ({handleText, defaultAnswer=null}) => {
  const [text, setText] = useState('');
  const [isValid, setValid]= useState(true);

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  useEffect(()=>{
    if(defaultAnswer && defaultAnswer.values){
      onChangeText(defaultAnswer.values[0])
    }
  },[])
    
  const onChangeText=(text: string)=>{
    setText(text);
  } 

  const onHandleInputText=()=>{
    if(isValidEmail(text))
    {
      if(handleText){
        handleText(text);
        setValid(true);
      }
    }else{
      onClearText();
      setValid(false);
    }
  }
  
  const onClearText = () => {
    setText('');
  };

  return (
    <View style={styles.inputWrapper}>
      {
        isValid ? null :(
          <Text style={styles.errorText}>
            {`Email không hợp lệ`}
          </Text>
        )
      }
      <TextInput style={styles.textField}
        value={text}
        onChangeText={(text)=>{
          onChangeText(text)
        }}
        onBlur={onHandleInputText}
        autoFocus={false}
        placeholder='Nhập email tại đây'
        placeholderTextColor={'#666666'}
        maxLength={50}
      />
    </View>
  );
};


const styles = StyleSheet.create({
    inputWrapper:{
      backgroundColor:'#FFFFFF',
      height:80,
      alignContent:'center',
      justifyContent:'center'
    },
    textField:{
      padding:10,
      marginTop:5,
      height:60,
      borderRadius: 10,
      borderColor:'#444444',
      borderWidth:1,
      textAlignVertical: 'center',
      fontFamily:FONT_STYLE.MEDIUM,
      fontSize:14
    },
    errorText:{
      padding: 5,
      fontSize:14,
      fontFamily: FONT_STYLE.MEDIUM,
      color:'red'
    }
})
export default Email;
